import * as React from 'react';
import {GoogleMap, withScriptjs, withGoogleMap, Marker} from 'react-google-maps';

export type MapProps = {
  lat: number;
  lng: number;
}

type Props = MapProps;

const Map: React.FC<Props> = ({lat, lng}) => {

  const options: google.maps.MapOptions = {
    disableDefaultUI: true,
    streetViewControl: true
  }

  return (
    <GoogleMap
      defaultZoom={15}
      defaultCenter={{ lat, lng }}
      defaultOptions={options}
    >
      <Marker position={{lat, lng}} />
    </GoogleMap>
  );
}
const GoogleMaps = withScriptjs(withGoogleMap(Map))

export default GoogleMaps;



// WEBPACK FOOTER //
// ./src/Components/GoogleMap.tsx